import { render, staticRenderFns } from "./RelatedProfiles.vue?vue&type=template&id=05e50d73&scoped=true"
import script from "./RelatedProfiles.vue?vue&type=script&lang=js"
export * from "./RelatedProfiles.vue?vue&type=script&lang=js"
import style0 from "./RelatedProfiles.vue?vue&type=style&index=0&id=05e50d73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e50d73",
  null
  
)

export default component.exports